// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorSampleRequests = (client) => ({
    /**
     * `POST /vendor/sample-requests/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSampleRequestsIdApproveCreate
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/vendor/sample-requests/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sample-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateSampleRequestForCustomer
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/sample-requests", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/sample-requests/:id/check-duplicates`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSampleRequestsIdCheckDuplicatesCreate
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/[id]/check-duplicates/route.ts
     */
    createCheckDuplicate: (id, body, query, headers) => client.fetch(buildPath("/vendor/sample-requests/:id/check-duplicates", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/sample-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSampleRequestsList
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/sample-requests", { method: "GET", query, headers }),
    /**
     * `GET /vendor/sample-requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSampleRequestsIdRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/sample-requests/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/sample-requests/:id/auto-assign-sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSampleRequestsIdAutoAssignSalesManagerRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/sample-requests/[id]/auto-assign-sales-manager/route.ts
     */
    retrieveAutoAssignSalesManager: (id, query, headers) => client.fetch(buildPath("/vendor/sample-requests/:id/auto-assign-sales-manager", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=sample-requests.js.map